import { CardConfig } from "@/types";
import { DateUtils } from "@/helpers/DateUtils";

export const policyCardConfig: CardConfig = {
  header: {
    icon: "spinner",
    iconSource: "$record.process.settings.icon",
    title: {
      source: "$record.custom_attributes.policy_number",
      formatter: (value) => `Número de póliza: ${value ?? "-"}`,
      classes: "text-gray-800 fw-bold col-12 fs-4",
    },
    subtitle: {
      source: "$record.process.name",
      classes: "text-gray-500 fw-bold col-12",
    },
  },
  body: [
    {
      id: "quoteNumber",
      title: "Número de cotización",
      source: "$record.custom_attributes.quote_number",
      component: "card-info-row",
      fallback: "-",
      classes: "bordered-bottom pb-2",
    },
    {
      id: "applicantsName",
      title: "Nombre del cliente",
      source: "$record.applicants_name",
      component: "card-info-row",
      fallback: "-",
      classes: "bordered-bottom pb-2",
      formatter: (value) => (value ? String(value).toUpperCase() : "-"),
    },
    {
      id: "identificationType",
      title: "Tipo de identificación",
      source: "$record.custom_attributes.identification_type.detalle",
      component: "card-info-row",
      fallback: "-",
      classes: "bordered-bottom pb-2",
    },
    {
      id: "identificationNumber",
      title: "Número de identificación",
      source: "$record.custom_attributes.identification_number",
      component: "card-info-row",
      fallback: "-",
      classes: "bordered-bottom pb-2",
    },
    {
      id: "quoteStatus",
      title: "Estado",
      source: "$record.grouped_tags.quote_status.0.name",
      component: "card-info-row",
      type: "vue-status-badge-v2",
      formatter: (value) => ({ label: value ?? "-", color: "color" }),
      classes: "bordered-bottom pb-2",
    },
    {
      id: "createdAt",
      title: "Fecha de creación",
      source: "$record.created_at",
      component: "card-info-row",
      fallback: "-",
      classes: "bordered-bottom pb-2",
      formatter: (value) => (value ? DateUtils.formatDateTime({ date: value }) : "-"),
    },
    {
      id: "createdBy",
      title: "Creado por",
      source: "$record.created_by.name",
      component: "card-info-row",
      fallback: "-",
    },
  ],
  footer: {
    bordered: true,
    classes: "justify-content-end",
    actions: [
      {
        id: "view",
        label: "Ver",
        classes: "btn btn-danger",
        icon: "eye",
        to: { name: "ReadPolicy", params: { id: "$record.id", stepId: "0001" } },
        conditions: [{ type: "can", values: [["applications-management.applications.read"]] }],
      },
    ],
  },
};
